import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import type { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const config = (
  resourceTypeEnum:
    | ResourceTypeEnum.ExternalEventContent
    | ResourceTypeEnum.LiveEventContent
    | ResourceTypeEnum.OfflineEventContent
    | ResourceTypeEnum.RecurringExternalEventContent
    | ResourceTypeEnum.RecurringLiveEventContent
    | ResourceTypeEnum.RecurringOfflineEventContent,
): ContentConfigProps => {
  return {
    routes: {
      details: routes.EventDetails,
      manageDetails: routes.AdminEventDetails,
    },
    label: RESOURCE_TYPE_LABEL_CONFIG[resourceTypeEnum],
    icons: {
      getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
    },
  };
};

export default config;
